import React from 'react';
export function RelatedArticles() {
  const preventScroll = e => {
    e.preventDefault();
  };
  return <div className="mt-8" data-id="element-116">
      <h3 className="text-lg font-bold mb-4 uppercase text-gray-700" data-id="element-117">
        Related Articles
      </h3>
      <div className="space-y-4" data-id="element-118">
        <a href="javascript:void(0)" onClick={preventScroll} className="block text-blue-600 hover:underline" data-id="element-119">
          The 7-Day Rule That Changes Everything
        </a>
        <a href="javascript:void(0)" onClick={preventScroll} className="block text-blue-600 hover:underline" data-id="element-120">
          Why No Contact Doesn't Work (And What to Do Instead)
        </a>
        <a href="javascript:void(0)" onClick={preventScroll} className="block text-blue-600 hover:underline" data-id="element-121">
          How to Make Him Miss You Desperately
        </a>
      </div>
    </div>;
}